<template>
  <div>
    <loading-screen :is-loading="isSaving"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <suggest-contacts-modal :hide-values="suggestContactsValuesToHide"
                            property="phone_number"
                            :modal-id="suggestModalId"
                            @contact-selected="handleSuggestContactSelected"
    ></suggest-contacts-modal>

    <!-- Description -->
    <div class="card shadow-none card-action">
      <div class="card-header">
        <div class="avatar-xxs d-inline-block mr-3">
                            <span class="avatar-title rounded bg-soft-primary text-primary font-size-14">
                                {{ $auth.user.name.charAt(0) }}
                            </span>
        </div>
        <b class="d-inline-block">Send SMS</b>
      </div>
      <!-- To field -->
      <div class="card-menubar card-menubar-top py-1 d-flex align-items-center">
        <label class="p-0 m-0" for="toField"><b>To:</b></label>
        <b-form-tags remove-on-delete tag-pills input-id="toField" v-model="toAddresses" class="border-0"
                     placeholder="Add mobile number..." add-on-change
                     duplicate-tag-text="Duplicate mobile number(s)"></b-form-tags>
        <div class="flex-shrink-1">
          <a href="#" @click="suggestForField('to')" class="mr-3">Suggest</a>
        </div>
      </div>
      <!-- / To field -->
      <!-- From field -->
      <div class="card-menubar card-menubar-top py-1 d-flex align-items-center">
        <label class="p-0 m-0" for="fromField"><b>From:</b></label>
        <b-form-select v-model="from" :options="fromOptions" class="border-0 my-1"
                       placeholder="Select phone number to send from"></b-form-select>
      </div>
      <!-- / From field -->
      <div class="card-body p-2">
        <textarea name="body" v-model="body" class="form-control border-0" rows="5"></textarea>
      </div>
      <div class="card-footer text-right">
        <button type="button" class="btn btn-itg mr-2" @click="attemptCancel">
          Cancel
        </button>

        <button type="button" class="btn btn-itg-dark" @click="send">
          Send
        </button>
      </div>
    </div>
    <!-- / Description -->

  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Forms from "../../../../../mixins/Forms";
import axios from 'axios';
import SuggestContactsModal from "./Reply/SuggestContactsModal";

export default {
  name: "SendSms",
  data() {
    return {
      suggestModalId: 'reply-suggest-modal',
      fieldSuggestingFor: null,

      isSaving: false,
      serverErrors: [],
      toAddresses: [],
      body: '',
      from: null,

      twilioPhoneNumbers: [],
      isLoadingTwilioPhonNumbers: false
    }
  },
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    isLoading() {
      return this.isLoadingTwilioPhoneNumbers;
    },

    fromOptions() {
      return _.map(this.twilioPhoneNumbers, function (phoneNumber) {
        return {
          value: phoneNumber.phone_number,
          text: phoneNumber.name + ' (' + phoneNumber.phone_number + ')'
        }
      });
    },

    suggestContactsValuesToHide() {
      if (this.fieldSuggestingFor === 'to') {
        return this.toAddresses;
      }

      return [];
    }
  },
  components: {SuggestContactsModal},
  mixins: [Forms],
  mounted() {
    this.loadTwilioPhoneNumbers();

    this.$nextTick(function () {
      window.setTimeout(function () {
        let container = document.getElementById('ticket-main-section-left-column');
        container.scrollTo({
          top: container.scrollHeight,
          behavior: "smooth",
          cancelable: false
        });
      }, 1);
    });
  },
  methods: {
    ...mapActions('ticketViewer', {
      cancelAction: 'cancelAction',
      actionComplete: 'actionComplete'
    }),

    loadTwilioPhoneNumbers() {
      let vm = this;
      vm.isLoadingTwilioPhoneNumbers = true;

      axios.get(API_BASE + '/twilio-phone-numbers').then(r => {
        vm.isLoadingTwilioPhoneNumbers = false;
        vm.twilioPhoneNumbers = r.data;

        let firstPhoneNumber = _.first(vm.twilioPhoneNumbers);
        if (firstPhoneNumber) {
          vm.from = firstPhoneNumber.phone_number;
        }
      }).catch(e => {
        vm.isLoadingTwilioPhoneNumbers = false;
        vm.setErrors(e);
      });
    },

    send() {
      if (this.isLoading) {
        return false;
      }

      let vm = this;
      vm.isSaving = true;
      vm.serverErrors = [];
      axios.post(API_BASE + '/tickets/' + this.ticket.id + '/sms', {
        to: this.toAddresses,
        from: this.from,
        body: vm.body
      }).then(r => {
        vm.isSaving = false;
        this.$notify.success({
          title: 'Success!',
          message: 'SMS sent successfully'
        });
        this.actionComplete();
      }).catch(e => {
        vm.isSaving = false;
        vm.setErrors(e);
      });
    },

    attemptCancel() {
      let vm = this;
      swal({
        title: "Are you sure you want to cancel?",
        text: "You have unsaved changes and your data will be lost.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Leave without saving"
        },
        dangerMode: true,
      }).then((shouldCancel) => {
        if (shouldCancel) {
          vm.cancelAction();
        }
      });
    },

    suggestForField(field) {
      this.fieldSuggestingFor = field;
      this.$bvModal.show(this.suggestModalId);
    },

    handleSuggestContactSelected(contact) {
      if (this.fieldSuggestingFor === 'to') {
        this.toAddresses.push(contact.phone_number);
      }
    }
  }
}
</script>

<style scoped>
.card {
  background-color: #f5f7f9;
}
</style>
